export default __webpack_public_path__ + "static/media/eraOfSmartWatches.ba42f5af.md";